import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const commonOptions = {
  organizationCategory: {
    private_activity: { pt: 'Atividade Privada (Empresas, ENI ou Liberais)', en: 'Private Activity (Companies, Sole Traders, or Professionals)' },
    nonprofit: { pt: 'Entidade Sem Fins Lucrativos', en: 'Non-Profit Entity' },
    state_business: { pt: 'Entidade Empresarial do Estado / Setor Público', en: 'State-Owned Enterprise / Public Sector' },
    public_sector: { pt: 'Organização Pública / Setor Estado', en: 'Public Organisation / State Sector' },
  },
  turnover: {
    small: { pt: '< 10M EUR', en: '< EUR 10M' },
    medium: { pt: '10M EUR - 50M EUR', en: 'EUR 10M - EUR 50M' },
    large: { pt: '> 50M EUR', en: '> EUR 50M' },
  },
  employees: {
    lt_50: { pt: '< 50', en: '< 50' },
    '50_249': { pt: '50 - 249', en: '50 - 249' },
    gte_250: { pt: '>= 250', en: '>= 250' },
  },
  hqGeo: {
    portugal: { pt: 'Portugal', en: 'Portugal' },
    eu: { pt: 'Outro país da UE', en: 'Another EU country' },
    outside_eu: { pt: 'Fora da UE', en: 'Outside the EU' },
  },
  serviceGeo: {
    eu: { pt: 'Portugal / UE', en: 'Portugal / EU' },
    outside_eu: { pt: 'Apenas fora da UE', en: 'Only outside the EU' },
  },
  digitalInfrastructureTypes: {
    electronic_communications: {
      pt: 'Operadoras de Telecomunicações e Redes Públicas de Comunicações',
      en: 'Telecom Operators and Public Communications Networks',
    },
    trust_services: {
      pt: 'Prestadores de Serviços de Confiança',
      en: 'Trust Service Providers',
    },
    dns_tld: {
      pt: 'Registos de Nomes de Domínio de Topo (TLD) e Fornecedores de Serviços DNS',
      en: 'Top-Level Domain Registries and DNS Service Providers',
    },
  },
  boolean: {
    true: { pt: 'Sim', en: 'Yes' },
    false: { pt: 'Não', en: 'No' },
  },
}

const organizationCategoryDescriptions = {
  private_activity: {
    pt: 'Sociedades comerciais (Lda., S.A., Unipessoais), Empresários em Nome Individual (ENI), Trabalhadores Independentes ou Profissionais Liberais com atividade económica ativa.',
    en: 'Commercial companies, sole traders, independent workers, or liberal professionals with active economic activity.',
  },
  nonprofit: {
    pt: 'Associações, IPSS, fundações ou cooperativas (ex: misericórdias com atividade na saúde, cooperativas de eletrificação).',
    en: 'Associations, social solidarity institutions, foundations, or cooperatives, such as healthcare charities or electrification cooperatives.',
  },
  state_business: {
    pt: 'Empresas controladas pelo Estado ou fundos públicos que vendem serviços ou gerem infraestruturas (ex: hospitais EPE, transportes públicos, águas municipais).',
    en: 'Entities controlled by the State or public funds that sell services or manage infrastructure, such as public hospitals, transport, or municipal water companies.',
  },
  public_sector: {
    pt: 'Ministérios, secretarias regionais, autarquias (municípios), forças de segurança ou agências reguladoras do Estado.',
    en: 'Ministries, regional secretariats, municipalities, security forces, or State regulatory agencies.',
  },
}

const digitalInfrastructureTypeDescriptions = {
  electronic_communications: {
    pt: '',
    en: '',
  },
  trust_services: {
    pt: 'Empresas que emitem certificados digitais, assinaturas eletrónicas ou selos temporais.',
    en: 'Companies that issue digital certificates, electronic signatures, or time stamps.',
  },
  dns_tld: {
    pt: '',
    en: '',
  },
}

const sectors = {
  energy: { pt: 'Energia', en: 'Energy' },
  transport: { pt: 'Transportes', en: 'Transport' },
  banking: { pt: 'Banca', en: 'Banking' },
  financial_market_infrastructure: { pt: 'Infraestruturas do mercado financeiro', en: 'Financial market infrastructure' },
  health: { pt: 'Saúde', en: 'Health' },
  drinking_water: { pt: 'Água potável', en: 'Drinking water' },
  wastewater: { pt: 'Águas residuais', en: 'Wastewater' },
  digital_infrastructure: { pt: 'Infraestruturas digitais', en: 'Digital infrastructure' },
  ict_service_management: { pt: 'Gestão de serviços TIC (B2B)', en: 'ICT service management (B2B)' },
  public_administration: { pt: 'Administração pública', en: 'Public administration' },
  space: { pt: 'Espaço', en: 'Space' },
  postal_courier: { pt: 'Serviços postais e de estafeta', en: 'Postal and courier services' },
  waste_management: { pt: 'Gestão de resíduos', en: 'Waste management' },
  chemicals: { pt: 'Produtos químicos', en: 'Chemicals' },
  food: { pt: 'Produção, transformação e distribuição de alimentos', en: 'Food production, processing, and distribution' },
  manufacturing: { pt: 'Indústria transformadora', en: 'Manufacturing' },
  digital_providers: { pt: 'Fornecedores digitais', en: 'Digital providers' },
  research: { pt: 'Investigação', en: 'Research' },
  none: { pt: 'Nenhum dos anteriores', en: 'None of the above' },
}

const subsectors = {
  electricity: { pt: 'Eletricidade', en: 'Electricity' },
  district_heating_cooling: { pt: 'Aquecimento e arrefecimento urbano', en: 'District heating and cooling' },
  oil: { pt: 'Petróleo', en: 'Oil' },
  gas: { pt: 'Gás', en: 'Gas' },
  hydrogen: { pt: 'Hidrogénio', en: 'Hydrogen' },
  air: { pt: 'Aéreo', en: 'Air' },
  rail: { pt: 'Ferroviário', en: 'Rail' },
  water: { pt: 'Marítimo e fluvial', en: 'Waterborne' },
  road: { pt: 'Rodoviário', en: 'Road' },
  credit_institutions: { pt: 'Instituições de crédito', en: 'Credit institutions' },
  trading_venues: { pt: 'Plataformas de negociação', en: 'Trading venues' },
  central_counterparties: { pt: 'Contrapartes centrais', en: 'Central counterparties' },
  healthcare_providers: { pt: 'Prestadores de cuidados de saúde', en: 'Healthcare providers' },
  eu_reference_laboratories: { pt: 'Laboratórios de referência da UE', en: 'EU reference laboratories' },
  medicinal_products_rnd: { pt: 'Investigação e desenvolvimento de medicamentos', en: 'Medicinal products R&D' },
  pharmaceutical_manufacturing: { pt: 'Fabricação de produtos farmacêuticos de base e preparações', en: 'Pharmaceutical manufacturing' },
  critical_medical_devices: { pt: 'Fabricação de dispositivos médicos críticos', en: 'Critical medical device manufacturing' },
  drinking_water_supply: { pt: 'Fornecimento e distribuição de água para consumo humano', en: 'Drinking water supply and distribution' },
  wastewater_collection_treatment: { pt: 'Recolha, eliminação ou tratamento de águas residuais', en: 'Wastewater collection, disposal, or treatment' },
  internet_exchange_point: { pt: 'Pontos de troca de tráfego de Internet (IXP)', en: 'Internet exchange points (IXP)' },
  dns_service_provider: { pt: 'Prestadores de serviços DNS', en: 'DNS service providers' },
  tld_registry: { pt: 'Registos de nomes de domínio de topo', en: 'Top-level domain registries' },
  cloud_provider: { pt: 'Prestadores de serviços de computação em nuvem', en: 'Cloud computing service providers' },
  data_centre: { pt: 'Prestadores de serviços de centro de dados', en: 'Data centre service providers' },
  cdn_provider: { pt: 'Prestadores de redes de distribuição de conteúdos', en: 'Content delivery network providers' },
  trust_services: { pt: 'Prestadores de serviços de confiança', en: 'Trust service providers' },
  public_electronic_communications_network: { pt: 'Prestadores de redes públicas de comunicações eletrónicas', en: 'Public electronic communications network providers' },
  public_electronic_communications_service: { pt: 'Prestadores de serviços de comunicações eletrónicas acessíveis ao público', en: 'Publicly available electronic communications services' },
  managed_service_provider: { pt: 'Prestadores de serviços geridos', en: 'Managed service providers' },
  managed_security_service_provider: { pt: 'Prestadores de serviços geridos de segurança', en: 'Managed security service providers' },
  central_government: { pt: 'Administração central', en: 'Central government' },
  regional_government: { pt: 'Administração regional', en: 'Regional government' },
  ground_based_infrastructure: { pt: 'Operadores de infraestruturas terrestres de apoio a serviços espaciais', en: 'Ground-based infrastructure supporting space services' },
  postal_services: { pt: 'Serviços postais', en: 'Postal services' },
  courier_services: { pt: 'Serviços de estafeta', en: 'Courier services' },
  waste_collection: { pt: 'Recolha de resíduos', en: 'Waste collection' },
  waste_treatment: { pt: 'Tratamento de resíduos', en: 'Waste treatment' },
  waste_disposal: { pt: 'Eliminação de resíduos', en: 'Waste disposal' },
  chemical_manufacturing: { pt: 'Fabricação de substâncias e produtos químicos', en: 'Chemical manufacturing' },
  chemical_distribution: { pt: 'Distribuição de substâncias e produtos químicos', en: 'Chemical distribution' },
  primary_production: { pt: 'Produção primária', en: 'Primary production' },
  food_processing: { pt: 'Transformação e fabricação de alimentos', en: 'Food processing and manufacturing' },
  food_distribution: { pt: 'Distribuição de alimentos', en: 'Food distribution' },
  medical_devices: { pt: 'Dispositivos médicos', en: 'Medical devices' },
  computers_electronics_optics: { pt: 'Computadores, eletrónica e ótica', en: 'Computers, electronics, and optics' },
  electrical_equipment: { pt: 'Equipamento elétrico', en: 'Electrical equipment' },
  machinery_equipment: { pt: 'Máquinas e equipamentos', en: 'Machinery and equipment' },
  motor_vehicles: { pt: 'Veículos automóveis', en: 'Motor vehicles' },
  other_transport_equipment: { pt: 'Outro equipamento de transporte', en: 'Other transport equipment' },
  online_marketplaces: { pt: 'Mercados em linha', en: 'Online marketplaces' },
  online_search_engines: { pt: 'Motores de pesquisa em linha', en: 'Online search engines' },
  social_network_platforms: { pt: 'Plataformas de redes sociais', en: 'Social networking platforms' },
  research_organisations: { pt: 'Organizações de investigação', en: 'Research organisations' },
}

const gapStatus = {
  implemented: { pt: 'Implementado', en: 'Implemented' },
  not_implemented: { pt: 'Não implementado', en: 'Not implemented' },
  partially_implemented: { pt: 'Parcialmente implementado', en: 'Partially implemented' },
  unsure: { pt: 'Não sei', en: "I'm not sure" },
}

const publicEntityCategory = {
  state_direct_large: {
    pt: 'Serviços da administração direta do Estado, centrais ou periféricos',
    en: 'Central or peripheral direct State administration services',
  },
  autonomous_region_direct_large: {
    pt: 'Serviços da administração direta das Regiões Autónomas, centrais ou periféricos',
    en: 'Central or peripheral direct administration services of the Autonomous Regions',
  },
  state_indirect_large: {
    pt: 'Entidades da administração indireta do Estado',
    en: 'Indirect State administration entities',
  },
  autonomous_region_indirect_large: {
    pt: 'Entidades da administração indireta das Regiões Autónomas',
    en: 'Indirect administration entities of the Autonomous Regions',
  },
  autonomous_admin_large: {
    pt: 'Entidades da administração autónoma',
    en: 'Autonomous administration entities',
  },
  public_business_above_medium: {
    pt: 'Entidade pública empresarial',
    en: 'Public business entity',
  },
  independent_administrative_entity: {
    pt: 'Entidade administrativa independente',
    en: 'Independent administrative entity',
  },
  constitutional_body: {
    pt: 'CES, Provedor de Justiça, serviços da Presidência da República, Assembleia da República, tribunais ou conselhos superiores',
    en: "Economic and Social Council, Ombudsman, Presidency of the Republic services, Assembly of the Republic, courts, or superior councils",
  },
  state_direct_medium: {
    pt: 'Serviços da administração direta do Estado, centrais ou periféricos',
    en: 'Central or peripheral direct State administration services',
  },
  autonomous_region_direct_medium: {
    pt: 'Serviços da administração direta das Regiões Autónomas, centrais ou periféricos',
    en: 'Central or peripheral direct administration services of the Autonomous Regions',
  },
  state_indirect_medium: {
    pt: 'Entidades da administração indireta do Estado',
    en: 'Indirect State administration entities',
  },
  autonomous_region_indirect_medium: {
    pt: 'Entidades da administração indireta das Regiões Autónomas',
    en: 'Indirect administration entities of the Autonomous Regions',
  },
  autonomous_admin_medium: {
    pt: 'Entidades da administração autónoma',
    en: 'Autonomous administration entities',
  },
  public_business_medium: {
    pt: 'Entidade pública empresarial',
    en: 'Public business entity',
  },
  public_other: {
    pt: 'Nenhuma das anteriores',
    en: 'None of the above',
  },
}

function pickLanguageValues(source, language) {
  return Object.fromEntries(Object.entries(source).map(([key, value]) => [key, value[language]]))
}

const pt = {
  translation: {
    documentTitle: 'Diagnóstico NIS2',
    appName: 'Diagnóstico NIS2',
    loading: {
      preparing: 'A preparar o diagnóstico...',
      report: 'A gerar o relatório...',
    },
    landing: {
      title: 'Diagnóstico NIS2 para âmbito, classificação e lacunas',
      description: 'Responda a um conjunto curto de perguntas e obtenha um relatório com classificação da entidade, exposição a coimas e lacunas práticas de preparação.',
      start: 'Iniciar diagnóstico',
      whatYouGet: 'O que recebe',
      sections: {
        scope: { title: 'Âmbito', description: 'Categoria, setor, dimensão e geografia.' },
        classification: { title: 'Classificação', description: 'Essencial, importante, estrangeira, pública, indireta ou fora de âmbito.' },
        readiness: { title: 'Preparação', description: 'Governação, incidentes, continuidade, fornecedores e MFA.' },
      },
      reportIncludes: 'O relatório gerado inclui referências legais, exposição a coimas, lacunas e ações recomendadas. É um diagnóstico inicial, não uma opinião jurídica.',
    },
    stages: {
      category: 'Categoria',
      impactTriage: 'Triagem de Impacto',
      dimension: 'Dimensão',
      geography: 'Geografia',
      sector: 'Setor',
      gaps: 'Lacunas',
      report: 'Relatório',
    },
    questionnaire: {
      progress: 'Progresso',
      shortcuts: 'As teclas numéricas selecionam respostas. Enter continua quando pode selecionar mais do que uma resposta.',
      back: 'Voltar',
      stepOf: 'Passo {{step}} de {{total}}',
      continue: 'Continuar',
      multiHelp: 'Selecione todas as opções aplicáveis ou continue sem selecionar nenhuma.',
      singleHelp: 'Escolha uma resposta para continuar. Também pode premir o número da resposta.',
      sectorCollection: {
        addSector: 'Adicionar setor',
        addAnother: 'Adicionar outro setor',
        chooseSector: 'Escolha um setor',
        chooseSubsector: 'Escolha um subsetor',
        chooseSuboptions: 'Selecione uma ou mais subopções.',
        multiHelp: 'Selecione todas as opções aplicáveis antes de continuar.',
        selectedSectors: 'Setores registados',
        noSectors: 'Ainda não adicionou nenhum setor.',
        noMoreSectors: 'Já adicionou todos os setores disponíveis.',
        removeTitle: 'Remover setor?',
        removeMessage: 'Esta ação remove o setor registado. Se for o último, o questionário volta à seleção inicial de setores.',
        cancel: 'Cancelar',
        confirmRemove: 'Remover',
        outOfScopeTitle: 'Sem enquadramento aparente',
        outOfScopeMessage: 'Pela ausência de enquadramento nas atividades listadas, a entidade não parece integrar o âmbito do RJC; recomenda-se a consulta ao CNCS para parecer vinculativo.',
        openMyCyber: 'Abrir MyCyber',
        returnHome: 'Voltar à página inicial',
      },
    },
    questions: {
      organizationCategory: { prompt: 'Categoria da organização' },
      triageSoleProvider: { prompt: 'Se a minha atividade não estiver disponível as pessoas podem ir a outra empresa da cidade ou perto para suprir as suas necessidades ou a infraestrutura da região fica bloqueada por falta de alternativa?' },
      triageSevereImpact: { prompt: 'Se os nossos sistemas digitais sofrerem um ataque ou pararem totalmente, isso coloca em risco imediato vidas humanas, a ordem pública ou pode causar um desastre ambiental na região?' },
      triageStateNotifiedCriticalEntity: { prompt: 'A sua empresa recebeu ou já tinha recebido no passado alguma notificação oficial, carta registada ou aviso formal das autoridades de cibersegurança a indicar que foi classificada como operadora crítica ou de serviços essenciais?' },
      turnover: { prompt: 'Qual é o volume de negócios anual?' },
      employees: { prompt: 'Quantos colaboradores tem a organização?' },
      hqGeo: { prompt: 'Onde está sediada a organização?' },
      serviceGeo: { prompt: 'Onde presta serviços?' },
      sectorCollection: { prompt: 'Quais são os setores da organização?' },
      digitalInfrastructureTypes: { prompt: 'Que tipos de infraestruturas digitais opera?' },
      primarySector: { prompt: 'Qual é o setor principal da organização?' },
      subsector: { prompt: 'Qual é o subsetor?' },
      isPublicBody: { prompt: 'A organização é uma entidade pública?' },
      publicEntityCategory: { prompt: 'Que tipo de entidade pública é a organização?' },
      gap_governance: { prompt: 'Está implementado um programa de formação e informação contínua que garanta aos órgãos de gestão da empresa o conhecimento necessário para a tomada de decisões estratégicas em cibersegurança?' },
      gap_incidents: { prompt: 'Consegue reportar um incidente ao CNCS em 24 horas e apresentar um relatório completo em 30 dias?' },
      gap_continuity: { prompt: 'Tem backups imutáveis contra ransomware?' },
      gap_supplyChain: { prompt: 'Audita a segurança dos fornecedores?' },
      gap_mfa: { prompt: 'MFA está aplicado em todos os sistemas?' },
    },
    helpers: {
      essential: 'Tipo: Entidade Essencial.',
      important: 'Tipo: Entidade Importante.',
    },
    questionHelpers: {
      triageSoleProvider: 'A sua organização opera como fornecedor único a nível regional de um serviço essencial. Se a atividade parar, afeta o funcionamento básico da sociedade, bloqueando imediatamente a vida quotidiana da população ou a economia local daquela região específica.',
      triageSevereImpact: 'Uma potencial interrupção dos serviços da organização causaria um impacto severo e direto na segurança pública, na saúde pública ou no ambiente.',
      triageStateNotifiedCriticalEntity: 'A organização foi formalmente identificada pelo Estado Português ou pelo CNCS como uma Entidade Crítica.',
    },
    questionNotes: {
      triageSoleProvider_select: 'Se for a única alternativa num raio de vários quilómetros ou num concelho isolado',
      triageSoleProvider_skip: 'Se facilmente se encontra concorrência na mesma localidade ou cidade, permitindo suprir as mesmas necessidades com um tempo de deslocação, proximidade geográfica ou facilidade de acesso semelhantes, sem grandes dificuldades acrescidas',
      triageSevereImpact_select: 'Se a paragem informática puder causar acidentes graves ou quebras de segurança física (ex: automação de ETARs/águas; sistemas de frio de laboratórios de análises; plataformas de videovigilância urbana ou controlo de resíduos químicos e perigosos, etc).',
      triageSevereImpact_skip: 'Se uma falha causar apenas prejuízos financeiros, atrasos comerciais ou incómodos logísticos que possam ser resolvidos mais tarde.',
      triageStateNotifiedCriticalEntity_select: 'Se a empresa já está listada oficialmente ao abrigo da legislação nacional de infraestruturas críticas e foi notificada diretamente pelo CNCS (Centro Nacional de Cibersegurança) ou ministérios da tutela.',
      triageStateNotifiedCriticalEntity_skip: 'Se nunca recebeu qualquer contacto formal ou auditoria de segurança por parte de organismos do Estado dedicados à proteção nacional.',
    },
    options: {
      organizationCategory: pickLanguageValues(commonOptions.organizationCategory, 'pt'),
      turnover: pickLanguageValues(commonOptions.turnover, 'pt'),
      employees: pickLanguageValues(commonOptions.employees, 'pt'),
      hqGeo: pickLanguageValues(commonOptions.hqGeo, 'pt'),
      serviceGeo: pickLanguageValues(commonOptions.serviceGeo, 'pt'),
      digitalInfrastructureTypes: pickLanguageValues(commonOptions.digitalInfrastructureTypes, 'pt'),
      boolean: pickLanguageValues(commonOptions.boolean, 'pt'),
      publicEntityCategory: pickLanguageValues(publicEntityCategory, 'pt'),
      sectors: pickLanguageValues(sectors, 'pt'),
      subsectors: pickLanguageValues(subsectors, 'pt'),
      gapStatus: pickLanguageValues(gapStatus, 'pt'),
    },
    optionDescriptions: {
      organizationCategory: pickLanguageValues(organizationCategoryDescriptions, 'pt'),
      digitalInfrastructureTypes: pickLanguageValues(digitalInfrastructureTypeDescriptions, 'pt'),
    },
    report: {
      newDiagnosis: 'Novo diagnóstico',
      title: 'Relatório de diagnóstico NIS2',
      copyLabel: 'Copiar ligação do relatório',
      copied: 'Ligação do relatório copiada.',
      sanctionExposure: 'Classificação',
      sanctionDetailLabel: 'Coimas aplicáveis em caso de incumprimento:',
      recommendedActions: 'Ações recomendadas',
      readinessGaps: 'Boas práticas recomendadas',
      measuresCompliant: '{{count}} de {{total}} medidas em conformidade',
      notAssessed: 'Não avaliado',
      ready: 'Preparado',
      gap: 'Lacuna',
      status: {
        compliant: 'CONFORME',
        partial: 'PARCIAL',
        gap: 'LACUNA',
      },
      legalReferences: 'Referências legais',
      disclaimer: 'Esta ferramenta fornece um diagnóstico inicial. Confirme as obrigações finais com aconselhamento jurídico e a autoridade competente.',
      url: 'URL do relatório:',
      fallbackReason: 'A classificação será gerada após a conclusão das respostas.',
      ctas: {
        primaryLabel: 'Descarregar relatório PDF',
        primaryLabelMyCiber: 'Registar no MyCiber',
        secondaryLabel: 'Agendar avaliação completa de lacunas',
        urgency: 'Guarde uma cópia do relatório em PDF para arquivo e partilha interna.',
      },
      waiverNote: 'O DL 125/2025 prevê uma dispensa de coima durante 12 meses para entidades com um procedimento interno de adaptação em curso.',
      doraAlert: 'Ao operar no setor das Infraestruturas do Mercado Financeiro tenha atenção, pois, maioria destas entidades é regulada pelo regulamento europeu DORA, que prevalece sobre a NIS2 nas obrigações digitais.',
    },
    classifications: {
      essential: 'Entidade Essencial',
      important: 'Entidade Importante',
      future_important: 'Entidade Importante Futura',
      foreign: 'Entidade Estrangeira',
      public: 'Entidade Pública Relevante',
      indirect: 'Âmbito Indireto',
      out_of_scope: 'Fora de Âmbito',
      pending: 'Pendente',
    },
    classificationReasons: {
      essential: 'Classificação como Entidade Essencial com base na categoria, na Triagem de Impacto, nas subopções de Infraestruturas Digitais, na dimensão ou no setor.',
      important: 'Classificação como Entidade Importante com base na dimensão e enquadramento nos anexos NIS2.',
      future_important: 'Classificação como Entidade Importante futura pelos critérios de enquadramento aplicáveis.',
      foreign: 'Entidade sediada fora da UE, com prestação de serviços na UE, exigindo representante na UE.',
      public: 'Entidade pública não classificada como Essencial ou Importante, enquadrada como Entidade Pública Relevante.',
      indirect: 'Micro ou pequena entidade em setor NIS2, permanecendo no âmbito indireto da cadeia de fornecimento.',
      out_of_scope: 'Atividade fora do âmbito de aplicação direta da NIS2 para os critérios fornecidos.',
    },
    sanctions: {
      titles: {
        essential: 'Entidade Essencial',
        important: 'Entidade Importante',
        future_important: 'Entidade Importante Futura',
        public: 'Entidade Pública Relevante',
        public_a: 'Entidade Pública Relevante (Grupo A)',
        indirect: 'Exposição indirecta | Cadeia de abastecimento',
        out_of_scope: 'Exposição indirecta | Cadeia de abastecimento',
        supply_chain: 'Exposição indirecta | Cadeia de abastecimento',
        not_applicable: 'Não aplicável',
        none: 'N/A',
      },
      details: {
        essential: '10.000.000 EUR ou 2% do volume de negócios anual global, consoante o valor mais elevado.',
        important: '7.000.000 EUR ou 1,4% do volume de negócios anual global, consoante o valor mais elevado.',
        future_important: 'Exposição projetada alinhada com os limiares de Entidade Importante se a exceção planeada se tornar aplicável.',
        public: 'Regime aplicável a Entidade Pública Relevante sem enquadramento no Grupo A.',
        public_a: 'Até 4.000.000 EUR.',
        indirect: 'A NIS2 pode não se aplicar diretamente, mas a entidade pode ainda ter de cumprir requisitos de cibersegurança por integrar a cadeia de fornecimento de uma organização regulada.',
        out_of_scope: 'A NIS2 pode não se aplicar diretamente, mas a entidade pode ainda ter de cumprir requisitos de cibersegurança por integrar a cadeia de fornecimento de uma organização regulada.',
        supply_chain: 'A NIS2 pode não se aplicar diretamente, mas a entidade pode ainda ter de cumprir requisitos de cibersegurança por integrar a cadeia de fornecimento de uma organização regulada.',
        not_applicable: 'Operando com origem e destino fora da UE, a análise preliminar exclui enquadramento territorial na NIS2; recomenda-se a validação oficial junto do CNCS para total segurança.',
        none: 'Sem mapeamento direto de coima para esta classificação.',
      },
    },
    articles: {
      governance: {
        title: 'Política de gestão de risco',
        description: 'Análise documentada do risco de cibersegurança e políticas de segurança da informação.',
      },
      incidents: {
        title: 'Gestão de incidentes',
        description: 'Procedimentos formais para detetar, responder e recuperar de incidentes de segurança.',
      },
      continuity: {
        title: 'Continuidade de negócio',
        description: 'Backups, recuperação de desastre e procedimentos de gestão de crise.',
      },
      supplyChain: {
        title: 'Segurança da cadeia de fornecimento',
        description: 'Práticas de segurança e avaliações sobre fornecedores e prestadores de serviços.',
      },
      mfa: {
        title: 'MFA e autenticação segura',
        description: 'Autenticação multifator ou contínua, comunicações seguras e acesso protegido aos sistemas.',
      },
    },
    legalRefs: {
      nis2: 'NIS2',
      dl125: 'DL 125/2025',
      art27: 'Art. 27',
      size: 'Dimensão',
    },
    footer: {
      legalTerms: 'Legal e Termos',
      copyright: '© 2026 CLML. Todos os direitos reservados.',
      built: 'Construído em Portugal. De confiança em toda a Europa.',
      language: 'Idioma',
      docs: 'Docs',
      status: 'Todos os sistemas operacionais',
      theme: {
        system: 'Sistema',
        light: 'Claro',
        dark: 'Escuro',
      },
    },
  },
}

const en = {
  translation: {
    documentTitle: 'NIS2 Diagnosis',
    appName: 'NIS2 diagnosis',
    loading: {
      preparing: 'Preparing diagnosis...',
      report: 'Generating report...',
    },
    landing: {
      title: 'NIS2 diagnosis for scope, classification, and gaps',
      description: 'Answer a short set of questions and get a report covering entity classification, sanction exposure, and practical readiness gaps.',
      start: 'Start diagnosis',
      whatYouGet: 'What you get',
      sections: {
        scope: { title: 'Scope', description: 'Category, sector, size, and geography.' },
        classification: { title: 'Classification', description: 'Essential, important, foreign, public, indirect, or out of scope.' },
        readiness: { title: 'Readiness', description: 'Governance, incidents, continuity, supplier security, and MFA gaps.' },
      },
      reportIncludes: 'The generated report includes legal references, sanction exposure, gap flags, and recommended actions. It is an initial diagnostic, not a legal opinion.',
    },
    stages: {
      category: 'Category',
      impactTriage: 'Impact Triage',
      dimension: 'Dimension',
      geography: 'Geography',
      sector: 'Sector',
      gaps: 'Gaps',
      report: 'Report',
    },
    questionnaire: {
      progress: 'Progress',
      shortcuts: 'Number keys select answers. Enter continues when more than one answer can be selected.',
      back: 'Back',
      stepOf: 'Step {{step}} of {{total}}',
      continue: 'Continue',
      multiHelp: 'Select all that apply, or continue with none selected.',
      singleHelp: 'Choose an answer to continue. You can also press the answer number.',
      sectorCollection: {
        addSector: 'Add sector',
        addAnother: 'Add another sector',
        chooseSector: 'Choose a sector',
        chooseSubsector: 'Choose a subsector',
        chooseSuboptions: 'Select one or more sub-options.',
        multiHelp: 'Select all applicable options before continuing.',
        selectedSectors: 'Registered sectors',
        noSectors: 'No sectors added yet.',
        noMoreSectors: 'All available sectors have already been added.',
        removeTitle: 'Remove sector?',
        removeMessage: 'This removes the registered sector. If it is the last one, the questionnaire returns to the initial sector selection.',
        cancel: 'Cancel',
        confirmRemove: 'Remove',
        outOfScopeTitle: 'No apparent coverage',
        outOfScopeMessage: 'Because the entity does not fit any of the listed activities, it does not appear to fall within the scope of the RJC; consultation with CNCS is recommended for a binding opinion.',
        openMyCyber: 'Open MyCyber',
        returnHome: 'Back to home',
      },
    },
    questions: {
      organizationCategory: { prompt: 'Organisation category' },
      triageSoleProvider: { prompt: 'If my activity is unavailable, can people go to another nearby company to meet their needs, or does the region’s infrastructure become blocked due to lack of alternatives?' },
      triageSevereImpact: { prompt: 'If our digital systems are attacked or stop completely, does that place human lives, public order, or the environment in the region at immediate risk?' },
      triageStateNotifiedCriticalEntity: { prompt: 'Has your company ever received any official notification, registered letter, or formal notice from cybersecurity authorities indicating that it was classified as a critical operator or essential service provider?' },
      turnover: { prompt: 'What is the annual turnover?' },
      employees: { prompt: 'How many employees does the organisation have?' },
      hqGeo: { prompt: 'Where is the organisation headquartered?' },
      serviceGeo: { prompt: 'Where does it provide services?' },
      sectorCollection: { prompt: 'Which sectors apply to the organisation?' },
      digitalInfrastructureTypes: { prompt: 'Which digital infrastructure types do you operate?' },
      primarySector: { prompt: 'What is the organisation’s primary sector?' },
      subsector: { prompt: 'What is the subsector?' },
      isPublicBody: { prompt: 'Is the organisation a public entity?' },
      publicEntityCategory: { prompt: 'What type of public entity is the organisation?' },
      gap_governance: { prompt: 'Does management have certified cybersecurity training?' },
      gap_incidents: { prompt: 'Can you report an incident to CNCS within 24 hours and submit a full report within 30 days?' },
      gap_continuity: { prompt: 'Do you have immutable backups against ransomware?' },
      gap_supplyChain: { prompt: 'Do you audit supplier security?' },
      gap_mfa: { prompt: 'Is MFA applied across all systems?' },
    },
    helpers: {
      essential: 'Type: Essential Entity.',
      important: 'Type: Important Entity.',
    },
    questionHelpers: {
      triageSoleProvider: 'Your organisation operates as the sole regional provider of an essential service. If the activity stops, it immediately disrupts the basic functioning of society, daily life, or the local economy in that specific region.',
      triageSevereImpact: 'A potential interruption of the organisation’s services would have a severe and direct impact on public safety, public health, or the environment.',
      triageStateNotifiedCriticalEntity: 'The organisation has been formally identified by the Portuguese State or the CNCS as a Critical Entity.',
    },
    questionNotes: {
      triageSoleProvider_select: 'If it is the only alternative within several kilometres or in an isolated municipality.',
      triageSoleProvider_skip: 'If comparable alternatives are easily available in the same locality or city, with similar travel time, proximity, and ease of access.',
      triageSevereImpact_select: 'If an IT outage could cause serious accidents or physical security failures, such as water treatment automation, laboratory cooling systems, urban video surveillance platforms, or hazardous waste controls.',
      triageSevereImpact_skip: 'If a failure would only cause financial losses, commercial delays, or logistical inconvenience that can be resolved later.',
      triageStateNotifiedCriticalEntity_select: 'If the company is already officially listed under national critical infrastructure legislation and was notified directly by CNCS or supervising ministries.',
      triageStateNotifiedCriticalEntity_skip: 'If it has never received any formal contact or security audit from State bodies dedicated to national protection.',
    },
    options: {
      organizationCategory: pickLanguageValues(commonOptions.organizationCategory, 'en'),
      turnover: pickLanguageValues(commonOptions.turnover, 'en'),
      employees: pickLanguageValues(commonOptions.employees, 'en'),
      hqGeo: pickLanguageValues(commonOptions.hqGeo, 'en'),
      serviceGeo: pickLanguageValues(commonOptions.serviceGeo, 'en'),
      digitalInfrastructureTypes: pickLanguageValues(commonOptions.digitalInfrastructureTypes, 'en'),
      boolean: pickLanguageValues(commonOptions.boolean, 'en'),
      publicEntityCategory: pickLanguageValues(publicEntityCategory, 'en'),
      sectors: pickLanguageValues(sectors, 'en'),
      subsectors: pickLanguageValues(subsectors, 'en'),
      gapStatus: pickLanguageValues(gapStatus, 'en'),
    },
    optionDescriptions: {
      organizationCategory: pickLanguageValues(organizationCategoryDescriptions, 'en'),
      digitalInfrastructureTypes: pickLanguageValues(digitalInfrastructureTypeDescriptions, 'en'),
    },
    report: {
      newDiagnosis: 'New diagnosis',
      title: 'NIS2 diagnosis report',
      copyLabel: 'Copy report link',
      copied: 'Report link copied.',
      sanctionExposure: 'Classification',
      sanctionDetailLabel: 'Applicable fines in case of non-compliance:',
      recommendedActions: 'Recommended actions',
      readinessGaps: 'Readiness measures',
      measuresCompliant: '{{count}} of {{total}} measures compliant',
      notAssessed: 'Not assessed',
      ready: 'Ready',
      gap: 'Gap',
      status: {
        compliant: 'COMPLIANT',
        partial: 'PARTIAL',
        gap: 'GAP',
      },
      legalReferences: 'Legal references',
      disclaimer: 'This tool provides an initial diagnostic. Confirm final obligations with counsel and the competent authority.',
      url: 'Report URL:',
      fallbackReason: 'The classification will be generated after all answers are completed.',
      ctas: {
        primaryLabel: 'Download PDF report',
        primaryLabelMyCiber: 'Register in MyCiber',
        secondaryLabel: 'Schedule a full gap assessment',
        urgency: 'Keep a PDF copy of the report for internal sharing and record-keeping.',
      },
      waiverNote: 'DL 125/2025 provides a 12-month fine waiver for entities with an internal adaptation procedure underway.',
      doraAlert: 'If you operate in the Financial Market Infrastructure sector, be aware that most of these entities are regulated by the European DORA Regulation, which prevails over NIS2 for digital obligations.',
    },
    classifications: {
      essential: 'Essential Entity',
      important: 'Important Entity',
      future_important: 'Future Important Entity',
      foreign: 'Foreign Entity',
      public: 'Relevant Public Entity',
      indirect: 'Indirect Scope',
      out_of_scope: 'Out of Scope',
      pending: 'Pending',
    },
    classificationReasons: {
      essential: 'Classified as an Essential Entity based on category, impact triage, selected digital infrastructure sub-options, size, or sector.',
      important: 'Classified as an Important Entity based on size and NIS2 annex scope.',
      future_important: 'Classified as a future Important Entity based on the applicable scope criteria.',
      foreign: 'Entity headquartered outside the EU while providing services in the EU, requiring an EU representative.',
      public: 'Public entity not classified as Essential or Important, scoped as a Relevant Public Entity.',
      indirect: 'Micro or small entity in a NIS2 sector, remaining in indirect supply-chain scope.',
      out_of_scope: 'Activity outside direct NIS2 scope for the criteria provided.',
    },
    sanctions: {
      titles: {
        essential: 'Essential Entity',
        important: 'Important Entity',
        future_important: 'Future Important Entity',
        public: 'Relevant Public Entity',
        public_a: 'Relevant Public Entity (Group A)',
        indirect: 'Indirect exposure | Supply chain',
        out_of_scope: 'Indirect exposure | Supply chain',
        supply_chain: 'Indirect exposure | Supply chain',
        not_applicable: 'Not applicable',
        none: 'N/A',
      },
      details: {
        essential: 'EUR 10,000,000 or 2% of global annual turnover, whichever is higher.',
        important: 'EUR 7,000,000 or 1.4% of global annual turnover, whichever is higher.',
        future_important: 'Projected exposure aligned with Important Entity thresholds if the planned exception becomes applicable.',
        public: 'Applicable regime for a Relevant Public Entity that does not fall under Group A.',
        public_a: 'Up to EUR 4,000,000.',
        indirect: 'NIS2 may not apply directly, but the entity may still be required to meet cybersecurity requirements as part of the supply chain of a regulated organisation.',
        out_of_scope: 'NIS2 may not apply directly, but the entity may still be required to meet cybersecurity requirements as part of the supply chain of a regulated organisation.',
        supply_chain: 'NIS2 may not apply directly, but the entity may still be required to meet cybersecurity requirements as part of the supply chain of a regulated organisation.',
        not_applicable: 'Operating with both origin and destination outside the EU, the preliminary analysis excludes territorial NIS2 coverage; official validation with CNCS is recommended for certainty.',
        none: 'No direct sanction mapping for this classification.',
      },
    },
    articles: {
      governance: {
        title: 'Risk management policy',
        description: 'Documented cybersecurity risk analysis and information security policies.',
      },
      incidents: {
        title: 'Incident handling',
        description: 'Formal procedures for detecting, responding to, and recovering from security incidents.',
      },
      continuity: {
        title: 'Business continuity',
        description: 'Backup management, disaster recovery plans, and crisis management procedures.',
      },
      supplyChain: {
        title: 'Supply chain security',
        description: 'Security practices and assessments across supplier and service provider relationships.',
      },
      mfa: {
        title: 'MFA and secure authentication',
        description: 'Multi-factor or continuous authentication, secure communications, and protected system access.',
      },
    },
    legalRefs: {
      nis2: 'NIS2',
      dl125: 'DL 125/2025',
      art27: 'Art. 27',
      size: 'Size',
    },
    footer: {
      legalTerms: 'Legal & Terms',
      copyright: '© 2026 CLML. All rights reserved.',
      built: 'Built in Portugal. Trusted across Europe.',
      language: 'Language',
      docs: 'Docs',
      status: 'All systems operational',
      theme: {
        system: 'System',
        light: 'Light',
        dark: 'Dark',
      },
    },
  },
}

i18n.use(initReactI18next).init({
  resources: { pt, en },
  lng: localStorage.getItem('nisform-language') || 'pt',
  fallbackLng: 'pt',
  interpolation: { escapeValue: false },
})

export default i18n
